import React from 'react';
import { FileText } from 'lucide-react';

interface ReportCoverProps {
  title: string;
  isEnglish: boolean;
}

export const ReportCover: React.FC<ReportCoverProps> = ({ title, isEnglish }) => (
  <div className="hidden print:block print:h-[calc(100vh-40mm)] print:w-full print:flex print:flex-col print:justify-between print:p-16 print:break-after-page">
    <div>
      <div className="flex justify-center mb-12">
        <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
          <FileText className="w-12 h-12 text-blue-600" />
        </div>
      </div>
      
      <h1 className="text-4xl font-bold text-center mb-8">
        {isEnglish ? 'Action Report' : 'Relatório de Ação'}
      </h1>
      
      <div className="text-2xl text-center text-gray-700">
        {title}
      </div>
    </div>
    
    <div className="text-center text-gray-600">
      <p className="text-sm mb-2">
        {isEnglish ? 'Generated by' : 'Gerado pelo'}
      </p>
      <p className="font-semibold">Hub de Engenharia da Zallpy</p>
      <p className="text-sm mt-2">
        {new Date().toLocaleDateString(isEnglish ? 'en-US' : 'pt-BR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
      </p>
    </div>
  </div>
);